import React from "react";
import { Box, Drawer, Fab, Tooltip } from "@mui/material";
import { Outlet } from "react-router-dom";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";
import { DevopsWorkspaceProvider, useDevopsWorkspace } from "../../contexts/DevopsWorkspaceContext";
import { DevopsChatProvider } from "../../hooks/useDevopsAgentChat";
import DevopsAgentCompanion from "./DevopsAgentCompanion";

const DRAWER_WIDTH = { xs: "100%", sm: 420, md: 480 };

const DevopsWorkspaceInner: React.FC = () => {
  const { agentOpen, openAgent, closeAgent } = useDevopsWorkspace();

  return (
    <Box sx={{ p: { xs: 1, md: 2 } }}>
      <Outlet />
      <Tooltip title="DevOps agent">
        <Fab
          color="primary"
          aria-label="Open DevOps agent"
          onClick={openAgent}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: (theme) => theme.zIndex.drawer - 1,
            display: agentOpen ? "none" : "flex",
          }}
        >
          <CloudQueueIcon />
        </Fab>
      </Tooltip>
      <Drawer
        anchor="right"
        open={agentOpen}
        onClose={closeAgent}
        keepMounted
        PaperProps={{
          sx: {
            width: DRAWER_WIDTH,
            maxWidth: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, height: "100%", display: "flex", flexDirection: "column" }}>
          <DevopsAgentCompanion />
        </Box>
      </Drawer>
    </Box>
  );
};

const DevopsWorkspaceLayout: React.FC = () => (
  <DevopsWorkspaceProvider>
    <DevopsChatProvider>
      <DevopsWorkspaceInner />
    </DevopsChatProvider>
  </DevopsWorkspaceProvider>
);

export default DevopsWorkspaceLayout;
